<div *ngIf="snapshot | async as snap">
    <div class="file">
        <mat-icon>description</mat-icon>
        <a href="{{downloadURL}}">{{file.name}}</a>
    </div>
  </div>